import { useState, useEffect } from 'react'

interface LogEntry {
  id: string
  timestamp: string
  level: 'info' | 'warn' | 'error' | 'debug'
  traceId: string
  message: string
  metadata?: Record<string, unknown>
}

const MOCK_LOGS: LogEntry[] = [
  { id: '1', timestamp: new Date().toISOString(), level: 'info', traceId: 'wa-msg-001-1728316800', message: 'Mensagem WhatsApp recebida', metadata: { type: 'text', userId: '5598999999999' } },
  { id: '2', timestamp: new Date(Date.now() - 60000).toISOString(), level: 'info', traceId: 'wa-msg-001-1728316800', message: 'Intenção classificada: QUALIFYING', metadata: { confidence: 0.92 } },
  { id: '3', timestamp: new Date(Date.now() - 120000).toISOString(), level: 'warn', traceId: 'llm-fallback-001', message: 'Claude API timeout — fallback para OpenAI', metadata: { provider: 'openai' } },
  { id: '4', timestamp: new Date(Date.now() - 180000).toISOString(), level: 'info', traceId: 'cal-schedule-001', message: 'Evento criado no Google Calendar', metadata: { eventId: 'evt_abc123' } },
  { id: '5', timestamp: new Date(Date.now() - 240000).toISOString(), level: 'error', traceId: 'zap-sign-001', message: 'Falha ao enviar contrato para assinatura', metadata: { error: 'Zapsign API 503' } },
]

export default function LogsPage() {
  const [logs, setLogs] = useState<LogEntry[]>([])
  const [filter, setFilter] = useState<string>('all')
  const [search, setSearch] = useState('')

  useEffect(() => {
    // TODO: Conectar com WebSocket ou API real de logs
    setLogs(MOCK_LOGS)
  }, [])

  const filteredLogs = logs.filter(log => {
    if (filter !== 'all' && log.level !== filter) return false
    if (search && !log.message.toLowerCase().includes(search.toLowerCase()) && !log.traceId.includes(search)) return false
    return true
  })

  const levelColor = (level: string) => {
    switch (level) {
      case 'error': return 'text-red-600 bg-red-50 dark:bg-red-900/20'
      case 'warn': return 'text-amber-600 bg-amber-50 dark:bg-amber-900/20'
      case 'debug': return 'text-gray-500 bg-gray-50 dark:bg-gray-800'
      default: return 'text-blue-600 bg-blue-50 dark:bg-blue-900/20'
    }
  }

  return (
    <div className="space-y-6 p-4 md:p-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Logs do Sistema</h1>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Buscar por mensagem ou trace ID..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-800 dark:text-white"
          />
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-800 dark:text-white"
          >
            <option value="all">Todos</option>
            <option value="info">Info</option>
            <option value="warn">Warn</option>
            <option value="error">Error</option>
            <option value="debug">Debug</option>
          </select>
        </div>
      </div>

      <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
        <table className="w-full text-left text-sm">
          <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
              <th className="px-4 py-3 font-medium text-gray-700 dark:text-gray-300">Timestamp</th>
              <th className="px-4 py-3 font-medium text-gray-700 dark:text-gray-300">Level</th>
              <th className="px-4 py-3 font-medium text-gray-700 dark:text-gray-300">Trace ID</th>
              <th className="px-4 py-3 font-medium text-gray-700 dark:text-gray-300">Mensagem</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {filteredLogs.map((log) => (
              <tr key={log.id} className="hover:bg-gray-50 dark:hover:bg-gray-800/50">
                <td className="whitespace-nowrap px-4 py-3 text-gray-600 dark:text-gray-400">
                  {new Date(log.timestamp).toLocaleString('pt-BR')}
                </td>
                <td className="px-4 py-3">
                  <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${levelColor(log.level)}`}>
                    {log.level.toUpperCase()}
                  </span>
                </td>
                <td className="max-w-[200px] truncate px-4 py-3 font-mono text-xs text-gray-600 dark:text-gray-400">
                  {log.traceId}
                </td>
                <td className="px-4 py-3 text-gray-900 dark:text-white">{log.message}</td>
              </tr>
            ))}
            {filteredLogs.length === 0 && (
              <tr>
                <td colSpan={4} className="px-4 py-8 text-center text-gray-500">
                  Nenhum log encontrado
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}